<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<h1>Copyright Information ©</h1>
<br/>
<p>James A. Pike and Robert J. Valenza (2020)</p>
<br/>
<p style="text-indent:0px;">The right of James A. Pike and Robert J. Valenza to be identified as authors of this work has been asserted by them in accordance with section 77 and 78 of the Copyright, Designs and Patents Act 1988.</p>
<br/>
<p style="text-indent:0px;">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.</p>
<br/>
<p style="text-indent:0px;">Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</p>
<br/>
<p style="text-indent:0px;">Austin Macauley is committed to publishing works of quality and integrity. In this spirit, we are proud to offer this book to our readers; however, the story, the experiences, and the words are the author’s alone.</p>
<br/>
<p style="text-indent:0px;">A CIP catalogue record for this title is available from the British Library.</p>
<br/>
<p style="text-indent:0px;">ISBN 9781528987165 (Paperback)</p>
<p style="text-indent:0px;">ISBN 9781528987172 (Hardback)</p>
<p style="text-indent:0px;">ISBN 9781528987196 (ePub e-book)</p>
<p style="text-indent:0px;">ISBN 9781528987189 (Audiobook)</p>
<br/>
<p style="text-indent:0px;">www.austinmacauley.com</p>
<br/>
<p style="text-indent:0px;">First Published (2020)</p>
<p style="text-indent:0px;">Austin Macauley Publishers Ltd</p>
<p style="text-indent:0px;">25 Canada Square</p>
<p style="text-indent:0px;">Canary Wharf</p>
<p style="text-indent:0px;">London</p>
<p style="text-indent:0px;">E14 5LQ</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?6fb6863a